import type { ApolloClient } from "@apollo/client";
import React, { type ReactElement, type ReactNode, useContext } from "react";

const ApolloRetryContext = React.createContext<null | ApolloClient<unknown>>(
  null,
);

export interface RetryApolloProviderProps<TCacheShape> {
  readonly children?: ReactNode;
  readonly client: ApolloClient<TCacheShape>;
}

export function RetryApolloProvider<TCacheShape = unknown>({
  client,
  children,
}: RetryApolloProviderProps<TCacheShape>): ReactElement<
  RetryApolloProviderProps<TCacheShape>
> {
  return (
    <ApolloRetryContext.Provider value={client}>
      {children}
    </ApolloRetryContext.Provider>
  );
}

export function useRetryApolloClient<TCache>(): ApolloClient<TCache> {
  const client = useContext(ApolloRetryContext);

  if (!client) {
    // https://github.com/apollographql/react-apollo/blob/5cb63b3625ce5e4a3d3e4ba132eaec2a38ef5d90/src/component-utils.tsx#L19-L22
    throw new Error(
      'Could not find "client" in the context or passed in as a prop. ' +
        "Wrap the root component in a <RetryApolloProvider>",
    );
  }
  return client as ApolloClient<TCache>;
}
